import React from 'react'

const Certificates = (props) => {
    return (
        <section id="certificates" className={`certificates-section section-padding ${props.sClass}`} style={{ paddingTop: '20px' }}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title text-center">
                            <h2>Our Certificates</h2>
                            <p>Registration certificate showcasing our compliance with legal, quality, and industry standards.</p>
                        </div>
                    </div>
                </div>
                
                {/* Certificates Section */}
                <div className="row justify-content-center mt-5">
                    <div className="col-12 col-lg-8">
                        <div className="certificate-wrapper" style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
                            <iframe
                                src="/certificate1.pdf"
                                width="100%"
                                height="600px"
                                style={{ border: 'none' }}
                                title="Quality Certificate"
                            >
                                <div style={{
                                    padding: '40px',
                                    textAlign: 'center',
                                    backgroundColor: '#f8f9fa',
                                    height: '600px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center'
                                }}>
                                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>📜</div>
                                    <h4>Quality Certificate</h4>
                                    <p>ISO 9001:2015 Certified</p>
                                    <a href="/certificate1.pdf" target="_blank" rel="noopener noreferrer" 
                                       style={{ color: '#0052DA', textDecoration: 'none' }}>
                                        View Certificate
                                    </a>
                                </div>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Certificates;